import LocationDetailUser from "../../components/locations/locationDetailUser";
/**
 * DetailUserLocationPage
 *
 * صفحه‌ای برای نمایش جزئیات مکان کاربر.
 *
 * @returns JSX.Element
 */

const DetailUserLocationPage = () => {
  return <LocationDetailUser />;
};

export default DetailUserLocationPage;
